import TextField from '@components/v2/form/TextField/TextField';
import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { InputAdornment } from '@mui/material';
import { Search, X } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';

interface SettingsMenuSearchProps {
  value: string;
  onValueChange: (value: string) => void;
  hasNoResults: boolean;
}

const SettingsMenuSearch = ({ value, onValueChange, hasNoResults }: SettingsMenuSearchProps) => {
  const { translate } = useTranslation();

  return (
    <>
      <TextField
        value={value}
        size="small"
        fullWidth
        autoComplete="off"
        placeholder={translate(LangEnum.GLOBAL_SEARCH)}
        sx={{
          '& .MuiOutlinedInput-root': { backgroundColor: 'background.paper' },
          '& .MuiOutlinedInput-input': {
            '&::placeholder': { color: 'text.tertiary', opacity: 1 },
          },
        }}
        onChange={(event) => onValueChange(event.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Icon icon={Search} size="md" />
              </InputAdornment>
            ),
            endAdornment: value ? (
              <InputAdornment position="end">
                <IconButton
                  icon={X}
                  size="medium"
                  ariaLabel={translate(LangEnum.GLOBAL_CLEAR)}
                  onClick={() => onValueChange('')}
                  sx={{
                    color: 'action.active',
                    '&:hover': { backgroundColor: 'transparent', color: 'text.primary' },
                  }}
                />
              </InputAdornment>
            ) : undefined,
          },
        }}
      />
      {hasNoResults && (
        <Typography variant="body2" color="text.secondary" align="center" sx={{ px: 1, pt: 2 }}>
          {translate(LangEnum.GLOBAL_NO_RESULTS)}
        </Typography>
      )}
    </>
  );
};

export default SettingsMenuSearch;
